// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { usePerformHapticFeedback, HapticsStyle } from '../utils/haptics/usePerformHapticFeedback';
import { usePlaySound } from '../sounds/usePlaySound';
import { SoundId } from '../sounds/soundConstants';

// Components
import Icon from './icons/Icon';

// Styles
import './Checkbox.scss';

const Checkbox = (props) => {
    const { error, checked, onClick, silent, ...otherProps } = props;
    const performHapticFeedback = usePerformHapticFeedback();
    const playSound = usePlaySound();

    const [animate, setAnimate] = React.useState(false);

    React.useEffect(() => {
        setAnimate(true);
        const animationTimeout = setTimeout(() => {
            setAnimate(false);
        }, 250);

        return () => clearTimeout(animationTimeout);
    }, [checked]);

    const handleOnClick = (event) => {
        performHapticFeedback(HapticsStyle.ImpactLight);
        // Task checkboxes have their own sounds (played from the task update itself)
        if (!silent) playSound(checked ? SoundId.CheckboxUntick : SoundId.CheckboxTick);

        if (onClick) {
            onClick(event);
        }
    };

    return (
        <div
            contentEditable={false}
            className={classNames('Checkbox', { error, checked, animate })}
            onClick={handleOnClick}
            {...otherProps}
        >
            <Icon name="checkbox-animated" />
        </div>
    );
};

Checkbox.propTypes = {
    onClick: PropTypes.func,
    checked: PropTypes.bool,
    error: PropTypes.bool,
    /** Suppress the generic checkbox tick/untick sound (e.g. for task items with their own sounds) */
    silent: PropTypes.bool,
};

export default Checkbox;
